import React from 'react';

import map from 'lodash/map';
import includes from 'lodash/includes';

import SiteViewerVersionComponentSelector
  from 'zoomforth_codesbane_viewer/component_lib/site_viewer_version_component_selector_container.jsx';

const DropdownTagsRenderer_ViewerVersion1 = ({ categoryId, categoryLabel, tags, selectedTagIds, onChange })=> (
  <div className="grid-section-filters-category">
    <div className="grid-section-filters-category-label">
      { categoryLabel }
    </div>

    <div className="grid-section-filters-category-tags">
      <select
        name={categoryId}
        onChange={(e)=> {
          onChange(categoryId, e.target.value);
        }}
      >
        <option
          value=""
          disabled
          selected
        >
          Select a filter
        </option>

        {
          map(tags, (tag)=> (
            <option
              key={tag.id}
              selected={includes(selectedTagIds, tag.id)}
              value={tag.id}
            >
              { tag.label }
            </option>
          ))
        }
      </select>
    </div>
  </div>
);

const DropdownTagsRenderer_ViewerVersion2 = ({ categoryId, categoryLabel, tags, selectedTagIds, onChange })=> (
  <div className="grid-section-filters-category">
    <label htmlFor={`dropdown-${categoryId}`} className="grid-section-filters-category-label">
      { categoryLabel }
    </label>

    <div className="grid-section-filters-category-tags">
      <select
        id={`dropdown-${categoryId}`}
        name={categoryId}
        onChange={(e)=> {
          onChange(categoryId, e.target.value);
        }}
      >
        <option value="" disabled selected>
          Select a filter
        </option>

        {
          map(tags, (tag)=> (
            <option
              key={tag.id}
              selected={includes(selectedTagIds, tag.id)}
              value={tag.id}
            >
              { tag.label }
            </option>
          ))
        }
      </select>
    </div>
  </div>
);

const DropdownTagsRenderer = (props)=> (
  <SiteViewerVersionComponentSelector>
    <DropdownTagsRenderer_ViewerVersion1 forSiteViewerVersion={1} { ...props } />
    <DropdownTagsRenderer_ViewerVersion2 forSiteViewerVersion={2} { ...props } />
  </SiteViewerVersionComponentSelector>
);

export default DropdownTagsRenderer;
